import React, { useState,useEffect,useMemo } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import Stack from "@mui/material/Stack";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Paper from "@mui/material/Paper";
import CircularProgress from '@mui/material/CircularProgress';
import GeneradorExcelExpedientes from "./BotonExcel";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import { Link } from "react-router-dom";
import MinimalPage from "../../layout/MinimalPage";
import api from "../../service/api";
import { setError } from "../../reducers/appSlice";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import VisorPdf from "../../components/Visorpdf";
import Modal from "../../components/Modal";
import SimpleTable from "../../components/SimpleTable";
import GeneradorPDF from "./GeneradorPDF";
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));


const validationSchema = Yup.object().shape({
  idTipo: Yup.number()
    .positive("Requerido"),
    
  codigoOrganismoGenerador: Yup.number(),
  organismoGenerador: Yup.string(),
  fechaDesde: Yup.date()
    .typeError('La fecha desde no es válida')
    .required('Requerido')
    .min(
      new Date(1992, 0, 1),
      'La fecha desde no puede ser anterior al 01/01/1992'
    ),
  fechaHasta: Yup.date()
    .typeError('La fecha hasta no es válida')
    .required('Requerida')
    .min(
      Yup.ref('fechaDesde'),
      'La fecha hasta no puede ser anterior a la fecha desde'
    )
    .test(
      'rango-maximo-un-anio',
      'El rango entre las fechas no puede ser mayor a un año',
      function (fechaHasta) {
        const { fechaDesde } = this.parent;

        if (!fechaDesde || !fechaHasta) {
          return true;
        }

        const desde = new Date(fechaDesde);
        const hasta = new Date(fechaHasta);

        const limite = new Date(desde);
        limite.setFullYear(limite.getFullYear() + 1);

        return hasta <= limite;
      }
    ),
});

const ConsultaGerencial = (props) => {
  const [buscandoOrganismoGenerador, setBuscandoOrganismoGenerador] = useState(false);
  const [headers,setHeaders] =useState([]);
  
  const dispatch = useDispatch();

  

  const leyendaOrganismoGenerador =
    "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Consulta de expedientes y trámites internos", ruta: "" },
  ];
  const [datos, setDatos] = useState([]);
  const [sinDatos, setSinDatos] = useState(true);
  const [filteredTramites, setFilteredTramites] = useState([]);
  const [filter, setFilter] = useState();;
  const [alignment, setAlignment] = React.useState("left");
  const [filtros, setFiltros] = useState({
    codigoOrganismoGenerador: "",
    organismoGenerador: "",
    idTipo: 0,
    fechaDesde: "",
    fechaHasta: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const [lblCriterios, setLblCriterios] = useState("Criterios de búsqueda");

  const [openDocumento, setOpenDocumento] = useState(false);

  const [documento, setDocumento] = useState("");

  const filterData = (element) => {
    const searchFilter = filter.toLowerCase();
    if(formik.values.idTipo===3){
      return (
        element.numero_expediente?.toLowerCase().includes(searchFilter) ||
        element.asunto?.toLowerCase().includes(searchFilter) ||
        element.fecha?.toLowerCase().includes(searchFilter) ||
        element.tematica?.toLowerCase().includes(searchFilter) ||
        element.descripcion_completa?.toLowerCase().includes(searchFilter)
      );
    }

    if(formik.values.idTipo===2){
      return (
        element.tematica?.toLowerCase().includes(searchFilter) ||
        element.digital?.toLowerCase().includes(searchFilter) ||
        element.cantidad?.toLowerCase().includes(searchFilter)
      );
    }
    if(formik.values.idTipo===1){
      return (
        element.numero_expediente?.toLowerCase().includes(searchFilter) ||
        element.asunto?.toLowerCase().includes(searchFilter) ||
        element.fecha_inicio?.toLowerCase().includes(searchFilter) ||
        element.tematica?.toLowerCase().includes(searchFilter) ||
        element.descripcion_completa?.toLowerCase().includes(searchFilter)
      );
    }
    
    
  };
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };
  useEffect(() => {
    if (datos) {
      if (datos.length > 0) {
        setSinDatos(false);
        if (filter) {
          setFilteredTramites(datos.filter(dato => filterData(dato)));
        } else {
          setFilteredTramites(datos);
        }
      }else{
        setFilteredTramites(datos);
        setSinDatos(true);
      }
    }
  }, [datos, filter]);
  const handleChangeFechaDesde = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaHasta = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  

  const handleCloseDocument = () => {
    setOpenDocumento(false);
  };


  const formik = useFormik({
    initialValues: {
      codigoOrganismoGenerador: "",
      organismoGenerador: "",
      idTipo: 0,
      fechaDesde: "",
      fechaHasta: "",
    },
    lblCriterios: "Criterios de búsqueda",
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
        formik.values.fechaDesde !== "" ||
        formik.values.fechaHasta !== "" ||
        formik.values.codigoOrganismoGenerador !== "" 
        ? setLblCriterios("Criterios aplicados")
        : setLblCriterios("Criterios de búsqueda");

      let body = {
        fechaDesde: values.fechaDesde,
        fechaHasta: values.fechaHasta,
        codigoOrganismoGenerador: values.codigoOrganismoGenerador,
        tipo: values.idTipo,
      };
      buscarTramites(body);
    },
    onReset: () => {
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
    },
  });

  

  const handleOrganismoGenerador = (organismoGenerador = null) => {
    if (organismoGenerador !== null) {
      formik.setFieldValue("codigoOrganismoGenerador", organismoGenerador.id);
      formik.setFieldValue("organismoGenerador", organismoGenerador.descOrgCompleta);
    } else {
      formik.setFieldValue("codigoOrganismoGenerador", "");
      formik.setFieldValue("organismoGenerador", "");
    }
  };



  const buscarOrganismoGeneradorPorCodigo = (codigoOrganismoGenerador) => {
    setBuscandoOrganismoGenerador(true);
    api
      .buscarOrganismo({
        id: codigoOrganismoGenerador,
        descripcion: "",
        alta: "N",
        accion: "consulta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismoGenerador(res.data[0]);
        } else {
          handleOrganismoGenerador();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismoGenerador();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismoGenerador(false);
      })
  };


  const handleCodigoOrganismoGenerador = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoGeneradorPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.organismoGenerador === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarOrganismoGeneradorPorCodigo(event.target.value);
    }
  };

  
  const handleChangeCodigoOrganismoGenerador = (event) => {
    if (formik.values.organismoGenerador !== "" && formik.values.organismoGenerador !== null) handleOrganismoGenerador();

    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("codigoOrganismoGenerador", event.target.value);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const buscarTramites = (filtros) => {
    setSubmitting(true);
    setDatos([]);
    if(filtros.fechaDesde === "" && filtros.fechaHasta === "" && filtros.codigoOrganismoGenerador==="" &&  filtros.tipo===0){
        return;
      }else{
        api
        .busqueda_gerencial(filtros)
        .then((res) => {
          setDatos(res.data);
          setFiltros(res.data);
        })
        .catch((e) => {
          dispatch(setError(e.response.data.error));
          console.log("Error al cargar los datos");
        })
        .finally(() => setSubmitting(false));
      }
    
  };

  const [expand, setExpand] = React.useState(true);
  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  const handleClickReset = () => {
    formik.handleReset();
  }
  
  useEffect(() => {

    if (Number(formik.values.idTipo) === 3) {
      setDatos([]);
      setHeaders(
          [
              { 
              id: "numero_expediente",
              numeric: true,
              disablePadding: true,
              label: "Expediente",
              width: 150,
              align: "right",
              },
              {
              id: "asunto",
              numeric: false,
              disablePadding: false,
              label: "Asunto",
              width: 150,
              align: "left",
              },
              {
              id: "fecha",
              numeric: false,
              disablePadding: false,
              label: "Fecha",
              width: 50,
              align: "center",
              },
              {
              id: "tematica",
              numeric: false,
              disablePadding: false,
              label: "Temática",
              width: 100,
              align: "left",
              },
              {
              id: "descripcion_completa",
              numeric: false,
              disablePadding: false,
              label: "Se ecuentra en",
              width: 400,
              align: "left",
              },
          ]
      ); 
  }


    if (Number(formik.values.idTipo) === 2) {
        setDatos([]);
        setHeaders([
            {
              id: "tematica",
              numeric: false,
              disablePadding: false,
              label: "Temática",
              width: 100,
              align: "left",
              sortable:true
            },
            { 
              id: "digital",
              numeric: false,
              disablePadding: false,
              label: "Tipo trámite",
              width: 150,
              align: "right",
              sortable:true
            },
         { 
           id: "cantidad",
           numeric: true,
           disablePadding: false,
           label: "Cantidad",
           width: 150,
           align: "right",
           sortable:true
         },
       ]); 
     }
     
     if (Number(formik.values.idTipo) === 1) {
        setDatos([]);
        setHeaders(
            [
                { 
                id: "numero_expediente",
                numeric: true,
                disablePadding: true,
                label: "Expediente",
                width: 150,
                align: "right",
                },
                {
                id: "asunto",
                numeric: false,
                disablePadding: false,
                label: "Asunto",
                width: 150,
                align: "left",
                },
                {
                id: "fecha_inicio",
                numeric: false,
                disablePadding: false,
                label: "Inicio",
                width: 50,
                align: "center",
                },
                {
                id: "tematica",
                numeric: false,
                disablePadding: false,
                label: "Temática",
                width: 100,
                align: "left",
                },
                {
                id: "descripcion_completa",
                numeric: false,
                disablePadding: false,
                label: "Generado por",
                width: 400,
                align: "left",
                },
            ]
        ); 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.idTipo]);
  const obtenerDatosExcel = async () => {
    const tipo = Number(formik.values.idTipo);
  
    if (!Array.isArray(filteredTramites)) {
      return [];
    }
  
    /*
     * TIPO 1
     */
    if (tipo === 1) {
      return filteredTramites.map((expediente) => ({
        expediente: expediente.numero_expediente ?? "",
        fechaInicio: expediente.fecha_inicio ?? "",
        tematica: expediente.tematica ?? "",
        descripcion: expediente.descripcion_completa ?? "",
        asunto: expediente.asunto ?? "",
        codigo_tema: expediente.codigo_tema ?? "",
        orf_id_generador: expediente.orf_id_generador ?? "",
      }));
    }
  
    /*
     * TIPO 2
     */
    if (tipo === 2) {
      const codigo = parseInt(
        formik.values.codigoOrganismoGenerador,
        10
      );
  
      const sinOrganismo = Number.isNaN(codigo);
  
      /*
       * CON organismo:
       * no hace falta llamar desplegarGerencial
       */
      if (!sinOrganismo) {
        return filteredTramites.map((expediente) => ({
          tematica:
            expediente.tematica ?? "Sin temática",
  
          digital:
            expediente.digital ?? "",
  
          cantidad:
            Number(expediente.cantidad) || 0,
        }));
      }
  
      /*
       * SIN organismo:
       *
       * Recién al tocar Excel buscamos
       * el detalle de cada temática.
       */
      const resultados = await Promise.all(
        filteredTramites.map(async (expediente) => {
  
          const response = await api.desplegarGerencial({
            tematica: parseInt(
              expediente.tematica_id,
              10
            ),
  
            digital:
              expediente.digital,
  
            codigoOrganismoGenerador:
              null,
  
            fechaDesde:
              formik.values.fechaDesde,
  
            fechaHasta:
              formik.values.fechaHasta,
          });
  
          const detalle = Array.isArray(response)
            ? response
            : response.data ?? [];
  
          return detalle.map((organismo) => ({
            tematica:
              expediente.tematica ?? "Sin temática",
  
            digital:
              expediente.digital ?? "",
  
            organismo:
              organismo.organismo ?? "",
  
            cantidad:
              Number(organismo.cantidad) || 0,
          }));
        })
      );
  
      return resultados.flat();
    }
  
    /*
     * TIPO 3
     */
    if (tipo === 3) {
      return filteredTramites.map((expediente) => ({
        expediente:
          expediente.numero_expediente ?? "",
  
        fecha:
          expediente.fecha ?? "",
  
        tematica:
          expediente.tematica ?? "",
  
        descripcion:
          expediente.descripcion_completa ?? "",
  
        asunto:
          expediente.asunto ?? "",
  
        codigo_tema:
          expediente.codigo_tema ?? "",
  
        orf_id_destino:
          expediente.orf_id_destino ?? "",
      }));
    }
  
    return [];
  };
  const DetalleGerencial = ({
    tematica,
    codigoOrganismoGenerador,
    fechaDesde,
    fechaHasta,
    digital,
  }) => {
    const [loading, setLoading] = useState(true);
    const [datos, setDatos] = useState([]);
  
    useEffect(() => {
      const cargarDatos = async () => {
        try {
          setLoading(true);
  
          const codigo = parseInt(codigoOrganismoGenerador, 10);
  
          const response = await api.desplegarGerencial({
            tematica: parseInt(tematica, 10),
            digital:digital,
            codigoOrganismoGenerador: Number.isNaN(codigo)
              ? null
              : codigo,
            fechaDesde:fechaDesde,
            fechaHasta:fechaHasta,
          });
  
          setDatos(
            Array.isArray(response)
              ? response
              : response.data ?? []
          );
        } catch (error) {
          console.error(error);
          setDatos([]);
        } finally {
          setLoading(false);
        }
      };
  
      cargarDatos();
    }, [
      tematica,
      codigoOrganismoGenerador,
      fechaDesde,
      fechaHasta,
    ]);
   
    if (loading) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            p: 2,
          }}
        >
          <CircularProgress size={24} />
        </Box>
      );
    }
  
    if (!datos.length) {
      return (
        <Typography sx={{ p: 2 }}>
          No se encontraron datos.
        </Typography>
      );
    }
  
    return (
      <Box
      sx={{
        width: "100%",
        maxWidth: 600,
        mx: "auto",
        p: 1.5,
      }}
    >
      <Box sx={{ p: 2 }}>
      <Stack spacing={1}>
        {datos.map((item) => (
          <Paper
            key={item.id}
            variant="outlined"
            sx={{
              px: 2,
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">
              {item.organismo}
            </Typography>

            <Typography
              variant="body2"
              fontWeight={700}
            >
              {item.cantidad}
            </Typography>
          </Paper>
        ))}
      </Stack>
    </Box>
    </Box>
    );
  };
  
  return (
    <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth>
      <Accordion sx={{ pl: 1, pr: 1 }} disableGutters expanded={expand} onChange={toggleAcordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-filtros"
          id="panel-filtros"
          sx={{ height: "50px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <FilterAltOutlinedIcon
              color={submitting ? "secondary" : "primary"}
              sx={{ mr: 1, display: { xs: "none", md: "inline" } }}
            />
            <Typography variant="cuerpo">{lblCriterios}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 1 }}>
          <form
            id="buscador"
            name="buscador"
            onSubmit={formik.handleSubmit}
            onReset={formik.handleReset}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
            <Grid item xs={12} sm={2}>
              <FormControl
                variant="outlined"
                size="small"
                fullWidth
                error={
                  formik.touched.idTipo &&
                  Boolean(formik.errors.idTipo)
                }
              >
                <InputLabel id="idTipoLabel">Tipo de informe</InputLabel>
                <Select
                  labelId="idTipoLabel"
                  id="idTipo"
                  name="idTipo"
                  variant="outlined"
                  label="Tipo de informe"
                  value={formik.values.idTipo}
                  onChange={formik.handleChange}
                >
                  <MenuItem value={0} selected >
                    Seleccione
                  </MenuItem>
                  <MenuItem value={1} selected >
                    Generados por dependencia
                  </MenuItem>
                  <MenuItem value={2} selected >
                    Por temáticas
                  </MenuItem>
                  <MenuItem value={3} selected >
                    Se encuetra en dependencia
                  </MenuItem>
                  
                </Select>
                <FormHelperText>
                  {formik.touched.idTipo && formik.errors.idTipo}
                </FormHelperText>
              </FormControl>
            </Grid>
                  <Grid item xs={12} lg={2}>
                    <TextField
                      id="codigoOrganismoGenerador"
                      name="codigoOrganismoGenerador"
                      label="Código de organismo"
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={formik.values.codigoOrganismoGenerador}
                      onChange={handleChangeCodigoOrganismoGenerador}
                      onKeyDown={handleCodigoOrganismoGenerador}
                      onBlur={handleCodigoOrganismoGenerador}
                      error={
                        formik.touched.codigoOrganismoGenerador && Boolean(formik.errors.codigoOrganismoGenerador)
                      }
                      helperText={formik.touched.codigoOrganismoGenerador && formik.errors.codigoOrganismoGenerador}
                    />
                    <Typography
                      variant="aclaracion"
                      sx={{
                        display: {
                          xs: "inline",
                          sm: "inline",
                          md: "inline",
                          lg: "none",
                        },
                      }}
                    >
                    {leyendaOrganismoGenerador}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Box display="flex" flexDirection="row">
                      <TextField
                        id="organismoGenerador"
                        name="organismoGenerador"
                        label="Organismo"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={formik.values.organismoGenerador}
                        onChange={formik.handleChangeOrganismoGenerador}
                        error={formik.touched.organismoGenerador && Boolean(formik.errors.organismoGenerador)}
                        helperText={formik.touched.organismoGenerador && formik.errors.organismoGenerador}
                        disabled
                      />
                      {buscandoOrganismoGenerador ? (
                        <CircularProgress
                          color="primary"
                          size={20}
                          sx={{ margin: 1 }}
                        />
                      ) : (
                          <BuscadorOrganismo resultado={handleOrganismoGenerador} activo={"T"} alta={"N"} accion="consulta" />
                        )}
                    </Box>
                  </Grid>
                <Grid item xs={12} lg={2} >
                <FormControl
                    variant="outlined"
                    size="small"
                    error={
                    formik.touched.fechaDesde && Boolean(formik.errors.fechaDesde)
                    }
                    fullWidth
                >
                    <TextField
                    id="fechaDesde"
                    type="date"
                    value={formik.values.fechaDesde}
                    label="Fecha de incio"
                    variant="outlined"
                    size="small"
                    onChange={handleChangeFechaDesde}
                    InputLabelProps={{ shrink: true }} />
                    <FormHelperText>
                    {formik.touched.fechaDesde && formik.errors.fechaDesde}
                    </FormHelperText>
                </FormControl>
                </Grid>
                <Grid item xs={12} lg={2}>
                <FormControl
                    variant="outlined"
                    size="small"
                    error={
                    formik.touched.fechaHasta && Boolean(formik.errors.fechaHasta)
                    }
                    fullWidth
                >
                    <TextField
                    id="fechaHasta"
                    type="date"
                    value={formik.values.fechaHasta}
                    label="Fecha hasta"
                    variant="outlined"
                    size="small"
                    onChange={handleChangeFechaHasta}
                    InputLabelProps={{ shrink: true }} />
                    <FormHelperText>
                    {formik.touched.fechaHasta && formik.errors.fechaHasta}
                    </FormHelperText>
                </FormControl>
                </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={2} sx={{ mt: 0, mb: 1, pt: 0 }}>
                  </Grid>
                  <Grid item xs={12} lg={10} sx={{ mt: 0, mb: 1, pt: 0 }}>
                    <Typography
                      variant="aclaracion"
                      
                      sx={{ml:2,
                        display: { xs: "none", sm: "none", md: "none", lg: "inline" },
                      }}
                    >
                      {leyendaOrganismoGenerador}
                    </Typography>
                  </Grid>
                </Grid>  
            <Grid container spacing={1} sx={{ pl: 2, pr: 1, paddingLeft: 1 }}>
              <Grid item lg={12} xs={12} align="right">
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Button
                    variant="plata"
                    type="button"
                    sx={{ m: 1 }}
                    endIcon={<CachedIcon />}
                    onClick={handleClickReset}
                  >
                    Limpiar
                </Button>{" "}
                  <Button
                    variant="gris"
                    type="submit"
                    disabled={submitting}
                    sx={{ m: 1 }}
                    endIcon={<SearchIcon />}
                  >
                    {submitting ? "Buscando..." : "Buscar"}
                  </Button>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <IconButton color="primary" type="reset" title="Limpiar">
                    <CachedIcon />
                  </IconButton>{" "}
                  <IconButton
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    title="Buscar"
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      <Paper sx={{py:2,px:2,mt:2 }} >
      <Toolbar disableGutters>
        <Grid container spacing={1} align="left">
          <Grid item align="left">
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: "wrap",
              }}
            >
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <TextField id="filtro" label="Buscar" variant="outlined" size="small" value={filter} onChange={(event) => setFilter(event.target.value)} />
                </Box> 
              <StyledToggleButtonGroup
                size="small"
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="text accionGrupal"
              >
            
                <GeneradorPDF expedientes={filteredTramites} tipo={formik.values.idTipo} />
                <GeneradorExcelExpedientes
                 obtenerDatos={obtenerDatosExcel}
                  tipo={formik.values.idTipo}
                  disabled={!Array.isArray(datos) || datos.length === 0}
                />
              </StyledToggleButtonGroup>
            </Paper>
          </Grid>
        </Grid>
      </Toolbar>
      <SimpleTable
        headers={headers}
        rows={filteredTramites.map((tramite) => {
          const tipo = Number(formik.values.idTipo);
          const mostrarLink = [1, 3].includes(tipo);
          return {
            ...tramite,
            
            numero_expediente:
              mostrarLink && tramite.tramite_id ? (
                <Link
                  to={`/ver_tramite/${tramite.tramite_id}`}
                  style={{
                    color: "inherit",
                    textDecoration: "underline",
                    fontWeight: 600,
                  }}
                >
                  {tramite.numero_expediente}
                </Link>
              ) : (
                tramite.numero_expediente
              ),
              expanded:
              tipo === 2 && tramite.codigoOrganismoGenerador===""? (
                <DetalleGerencial
                  tematica={parseInt(tramite.tematica_id,10)}
                  digital={tramite.digital}
                  codigoOrganismoGenerador={
                    tramite.codigoOrganismoGenerador != null
                      ? parseInt(tramite.codigoOrganismoGenerador, 10)
                      : null
                  }
                  fechaDesde={tramite.fechaDesde}
                  fechaHasta={tramite.fechaHasta}
                />
              ) : null,
          };
        })}
        dense
        expandable={Number(formik.values.idTipo) === 2 && formik.values.codigoOrganismoGenerador===""}
      />
      </Paper>
      
        

      <Modal open={openDocumento} handleClose={handleCloseDocument} closeButton>
        <VisorPdf url={"data:application/octet-stream;base64," + documento} />
      </Modal>

    </MinimalPage >
  );
};

export default ConsultaGerencial;